/**
 * ProgressBar — Barra de progresso com gradiente
 */
import type { JSX } from 'preact';
import { T } from '../../styles/tokens';

interface ProgressBarProps {
  value: number; // 0-100
  height?: number;
  gradient?: boolean;
  color?: string;
  animated?: boolean;
  label?: string;
  /** Posição do label: 'top' mostra acima da barra, 'bottom' (padrão) mostra abaixo */
  labelPosition?: 'top' | 'bottom';
  style?: JSX.CSSProperties;
}

export function ProgressBar({ value, height = 6, gradient = true, color, animated, label, labelPosition = 'bottom', style }: ProgressBarProps) {
  const pct = Math.max(0, Math.min(100, value));
  const bg = color || (gradient ? 'linear-gradient(90deg, #2F6BFF, #62D0FF)' : T.primary);

  const labelEl = label && (
    <div style={{
      display: 'flex', justifyContent: 'space-between',
      ...(labelPosition === 'top' ? { marginBottom: 3 } : { marginTop: 4 }),
      fontSize: labelPosition === 'top' ? 10 : 11,
      color: T.textMuted,
    }}>
      <span style={labelPosition === 'top' ? { fontWeight: 600, textTransform: 'uppercase' as any, letterSpacing: '0.5px', color: T.textSecondary } : undefined}>{label}</span>
      <span style={{ fontWeight: labelPosition === 'top' ? 600 : 700, color: labelPosition === 'top' ? T.textSecondary : (pct >= 90 ? T.success : pct >= 50 ? T.warning : T.danger) }}>
        {pct}%
      </span>
    </div>
  );

  const bar = (
    <div style={{
      height, borderRadius: height / 2,
      background: T.bgActive, overflow: 'hidden',
    }}>
      <div style={{
        height: '100%', borderRadius: height / 2,
        width: `${pct}%`,
        background: bg,
        transition: 'width 0.5s ease',
        ...(animated ? { animation: 'pulse-bar 2s ease-in-out infinite' } : {}),
      }} />
    </div>
  );

  return (
    <div style={style}>
      {labelPosition === 'top' && labelEl}
      {bar}
      {labelPosition === 'bottom' && labelEl}
    </div>
  );
}
